import { render, staticRenderFns } from "./TratamientoCapital.vue?vue&type=template&id=866d77f8&"
import script from "./TratamientoCapital.vue?vue&type=script&lang=js&"
export * from "./TratamientoCapital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports